import { useEffect, useState } from 'react';

import { DEFAULT_DELAY } from '@/constants';

export const useDebounce = <T,>(value: T, callback?: () => void, delay = DEFAULT_DELAY) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      callback?.();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, callback]);

  return debouncedValue;
};
